export const normalizeFormType = (formType: string | null | undefined): string =>
    String(formType || "")
        .trim()
        .toUpperCase()
        .replace(/\s+/g, " ")
        .replace(/\s*\(\s*/g, " (")
        .replace(/\s*\)\s*/g, ")")
        .replace(/\s*-\s*/g, " ")
        .trim();

export const isFormTypeMatch = (formType: string | null | undefined, target: string): boolean => {
    const normalized = normalizeFormType(formType);
    return normalized.startsWith(target);
};

export const isSaqDSpFormType = (formType: string | null | undefined): boolean =>
    isFormTypeMatch(formType, "SAQ D (SP)");

export const isSaqP2peFormType = (formType: string | null | undefined): boolean =>
    isFormTypeMatch(formType, "SAQ P2PE");

export const isSaqSpocFormType = (formType: string | null | undefined): boolean =>
    isFormTypeMatch(formType, "SAQ SPOC");

const applyCase = (value: string, replacement: string): string => {
    if (value.toUpperCase() === value) {
        return replacement.toUpperCase();
    }

    if (value[0] && value[0].toUpperCase() === value[0]) {
        return replacement.charAt(0).toUpperCase() + replacement.slice(1);
    }

    return replacement;
};

export const replaceMerchantTerms = (text: string): string => {
    if (!text) {
        return text;
    }

    const replacements: Array<{ pattern: RegExp; replacement: string }> = [
        { pattern: /\bmerchant['’]s\b/gi, replacement: "entity's" },
        { pattern: /\bmerchants\b/gi, replacement: "entities" },
        { pattern: /\bmerchant\b/gi, replacement: "entity" }
    ];

    return replacements.reduce((result, { pattern, replacement }) =>
        result.replace(pattern, (match) => applyCase(match, replacement)), text);
};
